export const GET_BNPL_DESCRIPTION = 'GET_BNPL_DESCRIPTION';
export const SET_BNPL_DESCRIPTION = 'SET_BNPL_DESCRIPTION';
export const GET_BNPL_DESCRIPTION_FAILED = 'GET_BNPL_DESCRIPTION_FAILED';
